export default "__VITE_ASSET__f15a6837__"